var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 16H16V496H496V16Z",
    fill: "#3498DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.607 359.472H437.091V151.139H124.607V359.472V359.472Z",
    fill: "#F1C40F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPw);
export default __webpack_public_path__ + "static/media/PW.d721d98ba747113f3521a2195f4c9aa9.svg";
export { ForwardRef as ReactComponent };